import React, { useContext } from "react";
import SettingsTopRow from "./SettingsTopRow";
import { css } from "emotion";
import TitleBlock from "../TitleBlock";
import headerShaded from "../../assets/images/header-shadow2.png";
import { GlobalContext } from "../../context/GlobalState";

const ManageWorkspaceMobileHeader = () => {
  const { currentWorkspace } = useContext(GlobalContext);
  return (
    <div className={container}>
      <SettingsTopRow />
      <TitleBlock
        title="Manage Workspace"
        subtitle={currentWorkspace.name.toUpperCase()}
        style="reverse-align"
      />
    </div>
  );
};

export default ManageWorkspaceMobileHeader;

const container = css`
  padding-bottom: 30px;
  background-image: url(${headerShaded});
  background-position: center bottom;
  min-height: 230px;
  background-repeat: no-repeat;
  background-size: 100% auto;
  .reverse-align {
    flex-direction: column-reverse;
  }
`;
